<template>
  <div class="dlg-header">
    <div class="dlg-badge">
      <v-icon color="white" size="20">{{ icon }}</v-icon>
    </div>
    <div class="dlg-heading">
      <span class="dlg-title">{{ title }}</span>
      <span v-if="subtitle" class="dlg-subtitle">{{ subtitle }}</span>
    </div>
    <v-spacer />
    <v-btn
      v-if="closable"
      icon
      small
      class="dlg-close"
      aria-label="Close dialog"
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
/**
 * Standardized soft-edge dialog header: gradient badge + title, with an optional
 * close button. Purely presentational — the parent owns all dialog state; this
 * component only emits `close` when the X is clicked.
 */
export default {
  name: 'DialogHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-card-text-outline',
    },
    subtitle: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
.dlg-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: #ffffff;
}
.dlg-badge {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.dlg-heading {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.dlg-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f2a55;
  line-height: 1.25;
}
.dlg-subtitle {
  font-size: 13px;
  color: #6b7a90;
  font-weight: 500;
  line-height: 1.3;
}
.dlg-close {
  color: #6b7a90;
}
</style>
